/* global REACT_APP_PUBLIC_FEATURE_FLAGS */

const getFeatureFlags = (): string[] => REACT_APP_PUBLIC_FEATURE_FLAGS;

export const useGetFeatureFlags = () => getFeatureFlags();

export const hasFeatureFlag = (flag: string) => getFeatureFlags().includes(flag);
